import { useState } from 'react';

export default function Features() {
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);

  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'No-Logs Policy',
      description: 'We never track, collect, or share your private data. Your online activity is yours alone.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Network',
      description: 'Access our worldwide server network for optimal speed and unrestricted content access.'
    },
    {
      icon: 'ri-shut-down-line',
      title: 'Kill Switch',
      description: 'Automatic protection that blocks all traffic if your VPN connection drops unexpectedly.'
    },
    {
      icon: 'ri-devices-line',
      title: 'Multi-Device',
      description: 'Protect all your devices simultaneously with a single account across platforms.'
    }
  ];

  return (
    <section id="features" className="bg-[#1a1a1a] py-40">
      <div className="max-w-[1280px] mx-auto px-20">
        <div className="text-center mb-20">
          <div className="mb-6">
            <span className="text-xs font-bold text-[#0066ff] tracking-[4px] uppercase">
              PROTECTION LAYERS
            </span>
          </div>
          <h2 className="text-6xl font-bold text-white">
            Your Security, Amplified
          </h2>
        </div>

        <div className="grid grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              onMouseEnter={() => setHoveredCard(index)}
              onMouseLeave={() => setHoveredCard(null)}
              className={`bg-[#252525] rounded-2xl p-6 border border-white/10 transition-all duration-300 cursor-pointer ${
                hoveredCard === index ? 'transform -translate-y-2 shadow-[0_16px_48px_rgba(0,102,255,0.2)]' : ''
              }`}
              style={{ height: '360px' }}
            >
              <div className="flex flex-col items-center text-center h-full">
                <div className="w-16 h-16 flex items-center justify-center mb-8 mt-4">
                  <i className={`${feature.icon} text-6xl text-[#0066ff]`}></i>
                </div>
                
                <h3 className="text-xl font-bold text-white mb-4">
                  {feature.title}
                </h3>
                
                <p className="text-[15px] text-[#a0a0a0] leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
